import { holdCompletionUntilLoaded } from "#/admin/legacy/page-builder/modal-completion.js";
import "#legacy/shared/sparkle_namespace.js";
import "#legacy/shared/components/modal.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

if (!Sparkle.PageBuilder.Modal) {
  Sparkle.PageBuilder.Modal = {};
}

Sparkle.PageBuilder.Modal.Base = class Base {
  getOutput() {
    // A function that returns the value of the completed form to be passed to the onComplete callback option
    throw "Implement this in your subclass";
  }

  constructor(options) {
    this.getOutput = this.getOutput.bind(this);
    this.handleComplete = this.handleComplete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.setContent = this.setContent.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.remove = this.remove.bind(this);
    if (options == null) {
      options = {};
    }
    this.options = jQuery.extend({ class: this.class }, options);

    this.modal = new WizardModal({
      ...this.options,
      header: null,
      body: null,
    }); // Remove header and body so we don't remove their event handlers during init since they actually should appear on the wizard's first page
    this.page = this.modal.addPage({
      header: this.options.header || this.title,
      body: this.options.body || Sparkle.HandlebarsTemplates[this.template](),
    });

    // BEHAVIOUR

    jQuery(this.modal).on("complete", this.handleComplete);
    jQuery(this.modal).on("cancel", this.handleCancel);
    jQuery(this.modal.container).on("hide", this.remove);
  }

  // EVENT HANDLERS

  handleComplete() {
    if (this.options.onComplete) {
      return this.options.onComplete(this.getOutput());
    }
  }

  handleCancel() {
    if (this.options.onCancel) {
      return this.options.onCancel(this.getOutput());
    }
  }

  // HELPER FUNCTIONS

  waitForChoices(promise) {
    return holdCompletionUntilLoaded(this.modal, promise);
  }

  setTitle(title) {
    return this.page.setHeader(title);
  }

  setContent(html) {
    return this.page.setBody(html);
  }

  show() {
    return this.modal.show();
  }

  hide() {
    return this.modal.hide();
  }

  remove() {
    return this.modal.destroy();
  }
};
Sparkle.PageBuilder.Modal.Base.prototype.template = "modal";
